<template>
    <v-overlay v-model="show" color="black">
        <v-card light width="480">
            <v-card-title>
                증빙발급
                <v-spacer />
                <v-icon @click="close">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text style="max-height: 80vh; overflow-y:auto;">
                <v-row align="baseline">
                    <v-col>발급유형</v-col>
                    <v-col><v-select v-model="input.type" :items="types" hide-details dense/></v-col>
                </v-row>
                <v-divider />
                <proof-issuance-cashbill v-if="input.type == '현금영수증'" v-model="input.data" />
                <proof-issuance-taxinvoice v-else-if="input.type == '세금계산서'" v-model="input.data" />
                <template v-else-if="input.type == '미발행'">
                    <v-row justify="center">
                        <v-col cols="auto">발급내역상세가 없습니다.</v-col>
                    </v-row>
                </template>
                <template v-else>
                    <v-row justify="center">
                        <v-col cols="auto">발급유형을 선택해주세요.</v-col>
                    </v-row>
                </template>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn @click="issue">발급하기</v-btn>
            </v-card-actions>
        </v-card>
    </v-overlay>
</template>

<script>
import dayjs from "dayjs";
import ProofIssuanceTaxinvoice from "./proof-issuance-taxinvoice.vue";
import ProofIssuanceCashbill from "./proof-issuance-cashbill.vue";
import api from "@/api";
export default {
    components: { ProofIssuanceTaxinvoice, ProofIssuanceCashbill },
    props: {
        value: {
            taxProof: {
                type: { type: String, default: null },
                data: { type: Array, default: [] },
            },
            payments: { type: Array, default: () => [] },
        },
    },
    data() {
        return {
            show: false,
            types: ["현금영수증", "세금계산서", "미발행"],
            input: {
                _contract: null,
                _payment: null,
                type: null,
                data: {},
            },
            amount: 0,
        };
    },
    methods: {
        init() {
            let { amount, purchaseDT, getData } = this;

            switch (this.input.type) {
                case "현금영수증":
                    this.input.data = {
                        documentNo: dayjs().format("YYYYMMDDHHmmss"),
                        orderNumber: this.value.contractNumber,
                        cost: amount.toString(),
                        ...getData(["tradeUsage", "identityNum"]),
                    };
                    break;
                case "세금계산서":
                    (() => {
                        const supplyCost = Math.round((amount / 11) * 10).toString();
                        this.input.data = {
                            writeDate: dayjs().format("YYYYMMDD"),
                            documentNo: dayjs().format("YYYYMMDDHHmmss"),
                            ...getData(["invoiceeType", "invoiceeCorpNum", "invoiceeCorpName", "invoiceeCEOName", "invoiceeEmail1"]),
                            totalAmount: amount.toString(),
                            purchaseDT,
                            itemName: "공사대금",
                            supplyCost,
                            tax: (amount - +supplyCost).toString(),
                        };
                    })();
                    break;
                case "미발행":
                    break;
                default:
                    break;
            }
        },
        open(item) {
            this.input._contract = this.value._id;
            this.input._payment = item._id;
            this.input.type = this.value.taxProof.type;
            this.amount = item.amount;
            this.purchaseDT = dayjs(item.wiredAt).format("YYYYMMDD");
            this.init();
            this.show = true;
        },
        close() {
            this.show = false;
        },
        async issue() {
            try {
                const { taxProof } = await api.console.contracts.taxProof.post(this.input);
                const target = this.value.payments.find(({ _id }) => taxProof._payment == _id);
                Object.assignDefined(target, { _taxProof: taxProof._id, taxProof });
                alert("증빙이 발급되었습니다.");
                this.$emit("input", this.value);
                this.close();
            } catch (error) {
                this.handleError(error);
            }
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
        getData(keys) {
            const { data } = this.value.taxProof;
            return keys.reduce((obj, key) => ({ ...obj, [key]: data.find((data) => data.key == key)?.value || "" }), {});
        },
    },
    watch: {
        "input.type"() {
            this.init();
        },
    },
};
</script>

<style></style>
